var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-container"},[_c('portal-target',{attrs:{"name":"modal-robo-employment"}}),_vm._v(" "),(!_vm.$route.query.view)?[_c('RoboTemplateList',{attrs:{"PCTRLLOG":_vm.CTRLLOG}})]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55e22854","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashBoard/Robo/RoboEmployment.vue
// module id = null
// module chunks = 